module.exports = __webpack_public_path__ + "static/poor-economics-99dfac67e51e5655cb8b116d0815ce04.jpg";